import { render, staticRenderFns } from "./ware-house-dialog.vue?vue&type=template&id=81e20f08&"
import script from "./ware-house-dialog.vue?vue&type=script&lang=js&"
export * from "./ware-house-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports